/**
 * Access token key name in local storage
 * @type {string}
 */
export const ACCESS_TOKEN_KEY = 'accessToken';

/**
 * Logged in user key name in local storage
 * @type {string}
 */
export const LOGGED_IN_USER_KEY = 'loggedInUser';

/**
 * Backend url for openapi
 * @type {string}
 */
export const BACKEND_URL =
    process.env.REACT_APP_BACKEND_URL ||
    import.meta.env.REACT_APP_BACKEND_URL ||
    'http://localhost:4000';

/**
 * Widget URL for the Fire Knife widget
 */
export const WIDGET_URL =
    process.env.REACT_APP_WIDGET_URL ||
    import.meta.env.REACT_APP_WIDGET_URL ||
    'https://widget.fire-knife.com';

/**
 * Stripe public key
 * @type {string}
 */
export const STRIPE_PUBLIC_KEY =
    process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    'pk_test_51QgstbGC1jddR1oek282TLmkik2MLBspCPEUq84BEfHTvLwa7U2HD6j5Z7ctRfhBF2gLjthfVxgNxC06KOM8GcbW00ACeNn11e';

/**
 * Minimum payment amount in cents
 * @type {number}
 */
export const minimumPaymentAmount = 100; // 1.00 USD

export const STATIC_CDN_URL =
    process.env.REACT_APP_STATIC_CDN_URL || 'https://images.fire-knife.com';

/**
 * Venue timezone for timeslot display/grouping. Set via REACT_APP_TIMEZONE in .env or build env.
 * @type {string}
 */
export const TIMEZONE =
    process.env.REACT_APP_TIMEZONE || import.meta.env.REACT_APP_TIMEZONE || 'Pacific/Honolulu';
